<template>
  <div class="kt-header kt-grid__item kt-header--fixed menu-design">
    <div class="kt-header__top">
      <div class="kt-container kt-container--fluid">
        <div class="kt-header__brand kt-grid__item">
          <NavbarMainLogo @onClick="openRoute('home')" />
        </div>
        <div class="kt-header__topbar kt-grid__item kt-grid__item--fluid">
          <NavbarMainItem
            class="kt-header__topbar-item--user"
            @click="openRoute('profile' )"
            v-tid:navbar-profile-button>
            <div class="kt-header__topbar-wrapper" data-toggle="tooltip" title="Profile">
              <span class="kt-header__topbar-username text-dark">
                {{ nickName }}
              </span>
              <img :src="personalInfo.avatar" v-if="false" />
              <img alt="Profile avatar" src="/img/user-avatar.png"/>
            </div>
          </NavbarMainItem>

          <NavbarMainItem @click="onShowSidebar" v-tid:navbar-menu-actions-button>
            <span class="kt-header__topbar-icon kt-header__topbar-icon--info"  data-toggle="tooltip" title="Menu">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="0" y="0" width="24" height="24"/>
                      <rect fill="#000000" x="4" y="4" width="7" height="7" rx="1.5"/>
                      <path d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z" fill="#000000" opacity="0.3"/>
                  </g>
              </svg></i>
            </span>
          </NavbarMainItem>
        </div>
      </div>
    </div>

    <Modal :show="isModalShow" @close="onCloseModal">
      <h1 class="text-center">Hello to the world Modal!</h1>
    </Modal>

    <Sidebar :show="isSidebarShow" @close="onCloseSidebar">
      <div class="col-md-12 text-center">
        <div class="kt-nav kt-nav--bold kt-nav--lg-space kt-nav--lg-font">
          <h4>Menu actions</h4>
          <div class="box_menu row">
            <div class="navOption col-md-6 col-6 menu-br menu-bb p-0">
              <a href="" class="kt-menu_option" @click.prevent="createOpportunity">
                <div>
                <svg class="svg-icon navSvgIconSize" viewBox="0 0 20 20">
                <path fill="none" d="M19.129,18.164l-4.518-4.52c1.152-1.373,1.852-3.143,1.852-5.077c0-4.361-3.535-7.896-7.896-7.896
                  c-4.361,0-7.896,3.535-7.896,7.896s3.535,7.896,7.896,7.896c1.934,0,3.705-0.698,5.078-1.853l4.52,4.519
                  c0.266,0.268,0.699,0.268,0.965,0C19.396,18.863,19.396,18.431,19.129,18.164z M8.567,15.028c-3.568,0-6.461-2.893-6.461-6.461
                  s2.893-6.461,6.461-6.461c3.568,0,6.46,2.893,6.46,6.461S12.135,15.028,8.567,15.028z"></path>
                </svg>
                </div>
                <div class="kt-nav__link-text">Search</div>
              </a>
            </div>
            <div class="navOption col-md-6 col-6 menu-bl menu-bb p-0">
              <a href="" class="kt-menu_option" @click.prevent="createOpportunity">
                <font-awesome-icon :icon="['fas', 'list-ul']" size="3x" />
                <div class="kt-nav__link-text">Create Opportunity</div>
              </a>
            </div>
            <div class="navOption col-md-6 col-6 menu-br menu-bt p-0">
              <a href="" class="kt-menu_option" @click.prevent="openRoute('quotes')">
                <font-awesome-icon :icon="['fas', 'globe-americas']" size="3x" />
                <div class="kt-nav__link-text">Opportunity List</div>
              </a>
            </div>
            <div class="navOption col-md-6 col-6 menu-bl menu-bt p-0">
              <a href="" class="kt-menu_option" @click.prevent="openRoute('drafts')">
                <font-awesome-icon :icon="['fas', 'user-edit']" size="3x" />
                <div class="kt-nav__link-text">Drafts</div>
              </a>
            </div>
            </div>
          </div>
          <div class="kt-nav__separator"></div>
          <div class="kt-nav__item d-flex justify-content-between mx-1">
            <span>{{ version }}</span>
            <a href="" class="kt-nav__link" @click.prevent="logout">
              <div class="text-right fw-400">Logout</div>
            </a>
          </div>
      </div>
    </Sidebar>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import NavbarMainLogo from '@/components/_shared/navbar-main/NavbarMainLogo.vue'
import NavbarMainItem from '@/components/_shared/navbar-main/NavbarMainItem.vue'
import Modal from '@/components/_shared/Modal.vue'
import Sidebar from '@/components/_shared/Sidebar.vue'
import ModalMixin from '@/mixins/modal'
import SidebarMixin from '@/mixins/sidebar'

import { uuid } from '@/helpers'

export default {
  name: 'NavbarMain',
  mixins: [ ModalMixin, SidebarMixin ],
  components: {
    NavbarMainLogo,
    NavbarMainItem,
    Modal,
    Sidebar
  },
  computed: {
    ...mapState(['appVersion']),
    ...mapGetters({
      'authUserData': 'auth/getAuthUserData'
    }),
    version () {
      return `v${this.appVersion}`
    },
    nickName () {
      if (this.authUserData) {
        if (this.authUserData.firstName) {
          return this.authUserData.firstName
        }
        if (this.authUserData.lastName) {
          return this.authUserData.lastName
        }
      }
      return 'Welcome'
    },
  },
  methods: {
    openRoute (name) {
      this.$router.push({ name }).catch(err => console.log('openRoute', err))
      this.onCloseSidebar()
    },
    logout () {
      this.$store.commit('auth/CLEAR_AUTH_DATA')
      window.location.href = '/'
    },
    createOpportunity () {
      const params = { privateId: uuid() }
      const location = { name: 'opportunity-details', params }
      this.$router
        .push(location)
        .catch(err => { console.log(err) })
    }
  }
}
</script>

<style lang="scss" scoped>
.kt-header--fixed {
  z-index: 3;
}
.kt-header__topbar-username {
  font-size: 1.05rem !important;
}
</style>
